/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { AddToFav } from "../components/PdtBlock/Right/RightContent";
import { ROOT } from "../constants";

export class CardHover extends React.Component {
  handleClick(e) {
    e.target.className =
      (e.target.className === "addToFav_btn" && "addToFav_btn active") ||
      "addToFav_btn";
  }
  render() {
    const { id } = this.props;
    const product = this.props.product.channelCatalogItem;
    const itemCode = this.props.product.channelCatalogItemCode;

    return (
      (product && (
        <div className="pdt_block" id={id}>
          <a
            className="pdtImg_link"
            href={`${ROOT}${product.productDetailUrl}`}
            style={{
              backgroundImage: `url(${product.images[0].url})`
            }}
          >
            <div
              className="pdtImghover_container"
              style={{
                backgroundImage: `url(${product.images[1].url})`
              }}
            />
          </a>
          {/* <span className="tag">{product.tag}</span> */}

          {/* <div className="colorOptions_wrap">
            <span className="colorOption bgColor-grey" />
            <span className="colorOption bgColor-greyLt" />
            <span className="colorOption bgColor-black" />
            <span className="colorOption bgColor-bronze" />
          </div> */}
          <div className="desc_wrap">

            <div className="collectionName">{product.prodname1}</div>
            <div className="name">{product.prodname2}</div>
            {/* <div className="originalPrice_wrap">
              <div className="price">{product.origPrice}</div>
            </div> */}
            {product.saleType &&
            ["normal", "display-show-price", "display-inventory"].includes(
              product.saleType
            ) ? (
              product.origPrice !== product.price ? (
                <React.Fragment>
                  <div
                    className="product-orignal-price"
                    style={{ fontSize: "12px" }}
                  >
                    {product.origPrice}
                  </div>
                  <div className="price">{product.price}</div>
                </React.Fragment>
              ) : (
                <div className="price">{product.origPrice}</div>
              )
            ) : product.saleType === "display" ? null : null}
          </div>
        </div>
      )) ||
      null
    );
  }
}
